import { NgControl } from '@angular/forms';
import { Directive, Input, DoCheck, HostListener } from '@angular/core';
import { debounceTime } from 'rxjs/operators';

@Directive({
    selector: '[appPhoneNumberValidation]'
})
export class PhoneNumberValidationDirective implements DoCheck {
    // tslint:disable-next-line:no-input-rename
    @Input('CompareModel') CompareModel: Array<any>;
    // tslint:disable-next-line:no-input-rename
    @Input('isRequired') isRequired: boolean;
    // tslint:disable-next-line:no-input-rename
    @Input('PhoneCountryCode') PhoneCountryCode: string;

    constructor(private formControl: NgControl) {

    }

    @HostListener('input', ['$event']) onEvent($event) {
        if (this.formControl) {
            this.formControl.control.valueChanges.pipe(debounceTime(1000)).subscribe((value) => {
                const tempPhoneString: string = value;
                if (this.isDefined(value)) {
                    value = value.replace(this.PhoneCountryCode, '');
                    value = value.replace(/[^\d]/g, '');
                    if (this.isDefined(this.PhoneCountryCode)) {
                        if (this.CompareModel.length > 1) {
                            if (this.CompareModel.filter(p => {
                                if (p.PhoneNumber === tempPhoneString && p.PhoneCountryCode === this.PhoneCountryCode) {
                                    return p;
                                }
                            }).length > 1) {
                                this.formControl.control.setErrors({ NotUnique: true });
                                this.formControl.control.markAsTouched();
                            }
                        }
                        if (value.length < 10 || value === '0000000000') {
                            this.formControl.control.setErrors({ incorrect: true });
                            this.formControl.control.markAsTouched();
                        }
                    } else if (this.isRequired === true && (value.length < 10 || value === '0000000000')) {
                        this.formControl.control.setErrors({ incorrect: true });
                        this.formControl.control.markAsTouched();
                    }
                }
            });
        }
    }

    ngDoCheck() {
    }

    isDefined(value) {
        if (value !== undefined && value != null && value !== '') {
            return true;
        } else {
            return false;
        }
    }
}
